import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/pal-intervju.jpeg";

function IntervjuPaalVinland() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.interviewPaalVinland.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.interviewPaalVinland.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/intervju-paal-vinland"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.interviewPaalVinland.title")}
          </h1>
          <p className="text-xl mb-2">
          {i18next.t("pages.articles.list.interviewPaalVinland.sections.intro")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.interviewPaalVinland.date")}
          </p>
        </div>
        <img
          src={article_img}
          className="w-full md:w-2/5"
          alt={i18next.t("pages.articles.list.interviewPaalVinland.imageAlt")}
        />
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.intro2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.intro3")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.intro4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPaalVinland.sections.lifeCycle.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.lifeCycle.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.lifeCycle.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.lifeCycle.content3")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.lifeCycle.content4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPaalVinland.sections.simplicity.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.simplicity.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.simplicity.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.simplicity.content3")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.simplicity.content4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPaalVinland.sections.newSolutions.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.newSolutions.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.newSolutions.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.newSolutions.content3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPaalVinland.sections.accessibility.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.accessibility.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.accessibility.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.accessibility.content3")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.accessibility.content4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPaalVinland.sections.curiosity.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.curiosity.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.curiosity.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPaalVinland.sections.curiosity.content3")}</p>

            <p className="mt-6 font-bold">
              {i18next.t("pages.articles.list.interviewPaalVinland.sections.closing")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntervjuPaalVinland;



